import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { Nullable } from '../../common/Nullable'

export interface GlobalAppError {
  type: null
  message?: null
  code: null
}
interface ErrorState {
  error: Nullable<GlobalAppError>
  errorMiddlewareEnabled: boolean
}
const initialState: ErrorState = {
  error: null,
  errorMiddlewareEnabled: true,
}
export const globalErrorSlice = createSlice({
  name: 'globalError',
  initialState,
  reducers: {
    setGlobalError: (state, { payload }) => {
      state.error = { type: payload.type, message: payload.message, code: payload.code }
    },
    clearGlobalError: (state) => {
      state.error = null
    },
    disableErrorMiddleware: (state) => {
      state.errorMiddlewareEnabled = false
    },
    enableErrorMiddleware: (state) => {
      state.errorMiddlewareEnabled = true
    },
  },
})

export const { setGlobalError, clearGlobalError, disableErrorMiddleware, enableErrorMiddleware } = globalErrorSlice.actions

export const selectGlobalError = (state: RootState) => state.globalError.error

export default globalErrorSlice.reducer
